module.exports = __webpack_public_path__ + "3786b80c89689c060e6a98f68fbac8b4.svg";